import { JsonObject, JsonProperty } from 'json2typescript';

@JsonObject('TournamentUser')
export class TournamentUser {

  @JsonProperty('user_id', Number)
  userId: number = 0;

  @JsonProperty('user_displayname', String, true)
  userDisplayname: string | null = null;

  @JsonProperty('best_points', Number)
  bestPoints: number = 0;

  @JsonProperty('is_reward_granted', Boolean)
  isRewardGranted: boolean = false;
}
